var _circle, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1329,
    cy: 27.7572,
    r: 21.2428,
    fill: "#20C67A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.0408,
    cy: 22.7757,
    rx: 0.291577,
    ry: 0.294252,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.4145,
    cy: 17.4791,
    rx: 0.583153,
    ry: 0.588504,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.205,
    cy: 30.4264,
    rx: 0.583154,
    ry: 0.588505,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3162,
    cy: 23.2173,
    rx: 1.60367,
    ry: 1.61839,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3367,
    cy: 33.3688,
    rx: 0.583154,
    ry: 0.588505,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2795 33.8584L20.7833 28.3118C20.4531 27.9785 20.4531 27.4382 20.7833 27.105L21.9791 25.8982C22.3093 25.5649 22.8447 25.5649 23.1749 25.8982L26.8774 29.6346L34.8078 21.6315C35.138 21.2983 35.6735 21.2983 36.0037 21.6315L37.1995 22.8383C37.5297 23.1715 37.5297 23.7118 37.1995 24.0451L27.4754 33.8585C27.1451 34.1917 26.6097 34.1917 26.2795 33.8584Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.78323,
    cy: 3.25723,
    r: 3.25723,
    fill: "#20C67A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.9249,
    cy: 9.06354,
    r: 2.54913,
    fill: "#20C67A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.3757,
    cy: 43.9017,
    r: 1.13295,
    fill: "#20C67A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.0838,
    cy: 41.2109,
    r: 1.5578,
    fill: "#20C67A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.9128a11c808d7e39027dc7b06050b60d.svg";
export { ForwardRef as ReactComponent };